// extracted by mini-css-extract-plugin
export default {"authentication":"App_authentication__CxTtI"};